export const NAV_ISOPEN = 'NAV_ISOPEN';
export const NAV_RESET = 'NAV_RESET';
export const NAV_SET_CURRENT_LEVEL = 'NAV_SET_CURRENT_LEVEL';
export const NAV_SET_CURRENT_EXPANDED = 'NAV_SET_CURRENT_EXPANDED';
export const NAV_RESET_CURRENT_EXPANDED = 'NAV_RESET_CURRENT_EXPANDED';

export const navIsOpenToggle = () => ({ type: NAV_ISOPEN });
export const navReset = () => ({ type: NAV_RESET });
export const navResetCurrentExpanded = () => ({ type: NAV_RESET_CURRENT_EXPANDED });
export const navSetCurrentLevel = currentLevel => ({ type: NAV_SET_CURRENT_LEVEL, currentLevel });
export const navSetCurrentExpanded = (level, currentExpanded) => ({
  type: NAV_SET_CURRENT_EXPANDED,
  level,
  currentExpanded
});
